var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"259908cebc8de6133160ea3f2a6272be0dc139eb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app@coordinape"]={id:"259908cebc8de6133160ea3f2a6272be0dc139eb"};
      